export default __webpack_public_path__ + "static/meta-image-8399227a31456735dbe61471366b6097.jpg";